<template>
  <div>
    <PageHeader
      title="E-books"
      :image="asset('images/helpers/me-ebooks.png')"
      description="I am excited to share my curated collection of e-books on health, happiness, and wellness with you! These books are full of insightful tips and practical advice that you can use to make positive changes in your life"
    >
      <SearchBar
        @onSubmit="searchSubmit"
        @onClear="searchCleared"
        v-model="searchInput"
      />
    </PageHeader>
    <Container>
      <div class="list" v-if="data.data.length > 0">
        <Item v-for="item in data.data" :key="item.id" :data="item" />
      </div>
      <NoData title="No e-books found" v-else>
        <span></span>
      </NoData>
      <Pagination :rawData="data.meta" :onClick="pageChange" class="mt-4" />
    </Container>
  </div>
</template>
<script>
import Item from "./item.vue";
import PageHeader from "../shared/pageHeader.vue";

export default {
  components: {
    Item,
    PageHeader,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        data: [],
        meta: {},
      }),
    },
    search: {
      type: String,
      default: "",
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(value) {
        this.searchInput = value;
      },
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
  methods: {
    searchSubmit(search) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: search,
          page: 1,
        })
      );
    },
    searchCleared() {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: "",
          page: 1,
        })
      );
    },
    pageChange(page) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          page: page,
          search: this.searchInput,
        })
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  grid-gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 1rem;
  }

  @media (max-width: 576px) {
    gap: 0.5rem;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }
}
</style>